import React from 'react';
import { Button, Icon, useTranslation } from '@testsigma/atoms';
import tickIcon from '@images/tick.svg';

import { useConnectionSyncSuccessful } from '../../hooks/use-sync-successful';
import { getIsGlobalConnection } from '@modules/salesforce/utils/utils';

export const MetadataSyncSuccess: React.FC = () => {
  const { t } = useTranslation();
  const isGlobalConnection = getIsGlobalConnection();

  const { handleClose, handleNavigateToTestCases } =
    useConnectionSyncSuccessful();


  return (
    <div className='flex flex-col py-10 pt-4 pb-6'>
      <Icon
        className='pr-3 text-xl cursor-pointer text-secondary-600 shrink-0 font-semibold self-end'
        onClick={handleClose}
        name={'close'}
      />
      <div className='flex flex-col items-center justify-center h-full'>
        <div className='mt-3 leading-8 font-semibold text-primary-1000 text-2xl'>
          {t('metadata-sync-scuess.label')}
        </div>

        <div className='my-10'>
          <img
            src={tickIcon}
            className='empty-illustration'
            alt='Tick Illustration'
          />
        </div>

        <span className='mb-10 text-center text-secondary-unique-600'>
          {!isGlobalConnection
            ? t('metadata-sync-scuess.description')
            : t('metadata-global-sync-success.description')}
        </span>

        {!isGlobalConnection && (
          <Button
            type='primary'
            onClick={() => {
              handleNavigateToTestCases();
            }}
          >
            {t('create-test-case.button.label')}
          </Button>
        )}
      </div>
    </div>
  );
};
